import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {AuthService} from '@shared/services/auth.service';
import {EQueryParam} from '@shared/enums/query-param';

export const canNotAuthGuard: CanActivateFn = (route, _state) => {
  if (inject(AuthService).user()) {
    // якщо вже авторизований — кидаємо на returnUrl або на дашборд
    const returnUrl = route.queryParamMap.get(EQueryParam.RETURN_URL) || '/';

    return inject(Router).createUrlTree([returnUrl]);
  }

  return true; // неавторизованим показуємо сторінку логіну
};
